import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pioneer-route-not-found',
  templateUrl: './route-not-found.component.html',
  styleUrls: [ './route-not-found.component.css' ]
})
export class RouteNotFoundComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/route-not-found/route-not-found.component.ts